import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categoria-conformidad',
  templateUrl: './categoria-conformidad.component.html',
  styleUrls: ['./categoria-conformidad.component.css']
})
export class CategoriaConformidadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
